import "./Home.module.css";
import GlobalNavigation from "@/reusable_sections/Header";
import TheMovingForce from "./sections/TheMovingForce";
import CoreCorporateValues from "./sections/CoreCorporateValues";
import FleetSolutions from "./sections/FleetSolutions";
import GlobalPulseStats from "./sections/GlobalPulseStats";
import WhyChooseUs from "./sections/WhyChooseUs";
import RequestGroundSupport from "./sections/RequestGroundSupport";
import AviationLogisticsFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <GlobalNavigation />
      <TheMovingForce />
      <CoreCorporateValues />
      <FleetSolutions />
      <GlobalPulseStats />
      <WhyChooseUs />
      <RequestGroundSupport />
      <AviationLogisticsFooter />
    </div>;
}